function initWatchScrollHero(config) {
  var section = document.getElementById(config.sectionId);
  var canvas = document.getElementById(config.canvasId);
  if (!section || !canvas) return;

  var ctx = canvas.getContext('2d');
  var frameCount = config.frameCount;
  var preloadCount = Math.min(config.preloadCount || frameCount, frameCount);
  var images = new Array(frameCount);
  var currentFrame = -1;
  var hasStartedScrolling = false;

  var hintEl = section.querySelector('[data-scroll-hint]');
  var progressEl = section.querySelector('[data-progress-fill]');
  var stageBg = section.querySelector('[data-stage-bg]');

  function framePath(i) {
    var padded = String(i).padStart(4, '0');
    return config.framePathBase + 'frame_' + padded + '.' + config.frameExt;
  }

  function resizeCanvas() {
    var dpr = window.devicePixelRatio || 1;
    canvas.width = canvas.clientWidth * dpr;
    canvas.height = canvas.clientHeight * dpr;
  }

  function hideStageBg() {
    if (stageBg) stageBg.classList.add('is-hidden');
  }

  function drawFrame(index) {
    var img = images[index];
    if (!img || !img.complete || img.naturalWidth === 0) return;

    var canvasRatio = canvas.width / canvas.height;
    var imgRatio = img.naturalWidth / img.naturalHeight;
    var drawWidth, drawHeight, offsetX, offsetY;

    if (imgRatio > canvasRatio) {
      drawHeight = canvas.height;
      drawWidth = drawHeight * imgRatio;
      offsetX = (canvas.width - drawWidth) / 2;
      offsetY = 0;
    } else {
      drawWidth = canvas.width;
      drawHeight = drawWidth / imgRatio;
      offsetX = 0;
      offsetY = (canvas.height - drawHeight) / 2;
    }

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);

    hideStageBg();
  }

  function loadImage(index) {
    if (images[index - 1]) return images[index - 1];
    var img = new Image();
    img.src = framePath(index);
    images[index - 1] = img;
    return img;
  }

  // Preload the first N frames immediately (blocking-ish, but async)
  for (var i = 1; i <= preloadCount; i++) {
    (function (idx) {
      var img = loadImage(idx);
      if (idx === 1) {
        img.onload = function () {
          resizeCanvas();
          drawFrame(0);
        };
      }
    })(i);
  }

  // Lazily load the rest after the page finishes loading
  window.addEventListener('load', function () {
    setTimeout(function () {
      for (var i = preloadCount + 1; i <= frameCount; i++) {
        loadImage(i);
      }
    }, 50);

    // Safety net: no matter what happened above, the stage background
    // should never still be showing once the page has fully loaded.
    // This is what fixes the box getting stuck visible if the very
    // first frame was slow to report back or the canvas wasn't sized
    // yet at that exact moment.
    setTimeout(hideStageBg, 300);
  });

  function updateFromScroll() {
    var rect = section.getBoundingClientRect();
    var scrollDistance = section.offsetHeight - window.innerHeight;
    if (scrollDistance <= 0) return;

    var scrolled = -rect.top;
    var progress = Math.min(Math.max(scrolled / scrollDistance, 0), 1);

    if (progress > 0.005 && !hasStartedScrolling) {
      hasStartedScrolling = true;
      if (hintEl) hintEl.classList.add('is-hidden');
      // The moment the user starts scrolling, hide the stage
      // background unconditionally — by then something should be
      // visible on the canvas regardless of load timing.
      hideStageBg();
    }

    var frameIndex = Math.min(
      frameCount - 1,
      Math.floor(progress * (frameCount - 1))
    );

    if (frameIndex !== currentFrame) {
      currentFrame = frameIndex;
      drawFrame(currentFrame);
    }

    if (progressEl) {
      progressEl.style.width = (progress * 100).toFixed(2) + '%';
    }
  }

  window.addEventListener('resize', function () {
    resizeCanvas();
    if (currentFrame >= 0) drawFrame(currentFrame);
  });

  window.addEventListener('scroll', updateFromScroll, { passive: true });

  resizeCanvas();
  updateFromScroll();
}

document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('[data-watch-scroll-hero]');
  sections.forEach(function (section) {
    var canvas = section.querySelector('canvas');
    if (!canvas) return;

    initWatchScrollHero({
      sectionId: section.id,
      canvasId: canvas.id,
      frameCount: parseInt(section.dataset.frameCount, 10),
      preloadCount: parseInt(section.dataset.preloadCount, 10),
      framePathBase: section.dataset.framePathBase,
      frameExt: section.dataset.frameExt
    });
  });

  // Same reveal-on-scroll animation used by the Video Banner section
  var animEls = document.querySelectorAll('[data-watch-scroll-hero] [data-anim]');
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
        } else {
          entry.target.classList.remove('in-view');
        }
      });
    },
    { threshold: 0.35 }
  );
  animEls.forEach(function (el) {
    observer.observe(el);
  });
});
